import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useNProgress } from '@tanem/react-nprogress'

import _ from '../styles/global.scss';

import Home from './Home';
import Terms from './Terms';
import Privacy from './Privacy';
import Contact from './Contact';
import Android from './Android';
import CommunityGuidelines from './CommunityGuidelines';
import EmailSuccess from './EmailSuccess';
import NoMatch from './NoMatch';
import Bar from './Bar';
import LanguageDropdown from './LanguageDropdown';
import Footer from './Footer';

const Progress = ({ isAnimating }) => {
    const { animationDuration, isFinished, progress } = useNProgress({
        isAnimating,
    })

    return (
        <Container animationDuration={animationDuration} isFinished={isFinished}>
            <Bar animationDuration={animationDuration} progress={progress} />
        </Container>
    )
}

const Container = ({ animationDuration, children, isFinished }) => (
    <div
      style={{
        opacity: isFinished ? 0 : 1,
        pointerEvents: 'none',
        transition: `opacity ${animationDuration}ms linear`,
      }}
    >
      {children}
    </div>
)

const NavigationRoutes = () => {
    const location = useLocation();
    const [translations, setTranslations] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);

        setTimeout(() => {
            setIsLoading(false);
        }, 300);

        const locale = location.pathname.split('/')[1];

        const fetchTranslations = async () => {
            const response = await fetch(`/${locale}.json`);

            setTranslations(await response.json())
        };

        fetchTranslations()
            .catch(console.error);
    }, [location])

    const locale = location.pathname.split('/')[1];

    if (window.location.host.split(".")[0] == "support") {
        return (
            <>
                <Progress isAnimating={isLoading} key={location.key} />
                <Routes location={location}>
                    <Route exact path="/:language" element={<Contact locale={locale} translations={translations} />} />
                    <Route path="*" element={<Contact locale={locale} translations={translations} />} />
                </Routes>
            </>
        );
    } else {
        return (
            <>
                <LanguageDropdown locale={locale} translations={translations} />
                {/*
                Setting a key means that a new NProgress instance is created if
                the location is changing, giving us the UI behaviour we want. See:
                https://reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#recommendation-fully-uncontrolled-component-with-a-key.
                */}
                <Progress isAnimating={isLoading} key={location.key} />
                <Routes location={location}>
                    <Route exact path="/:language" element={<Home locale={locale} translations={translations} />} />
                    <Route exact path="/:language/terms" element={<Terms locale={locale} translations={translations} />} />
                    <Route exact path="/:language/privacy" element={<Privacy locale={locale} translations={translations} />} />
                    <Route exact path="/:language/contact" element={<Contact locale={locale} translations={translations} />} />
                    <Route exact path="/:language/community-guidelines" element={<CommunityGuidelines locale={locale} translations={translations} />} />
                    <Route exact path="/:language/email-success" element={<EmailSuccess />} />
                    <Route exact path="/:language/android" element={<Android locale={locale} translations={translations} />} />
                    <Route path="*" element={<NoMatch locale={locale} translations={translations} />} />
                </Routes>
                <Footer locale={locale} translations={translations} />
            </>
        );
    }
};

export default NavigationRoutes;
